"use client"

import { useLanguage } from "../../context/LanguageContext"
import "./WeatherSummary.css"

const WeatherSummary = ({ weatherData, forecastData }) => {
  const { t } = useLanguage()

  if (!weatherData) return null

  const {
    temperature,
    windSpeed,
    humidityMax,
    humidityMin,
    tempMax,
    tempMin,
    tempAvg,
    uz,
    zw,
    n,
    date,
    country,
    locationName,
  } = weatherData

  const time = new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })

  const getWeatherIcon = () => "fa-cloud-sun" // default icon

  const formatDay = (dateString) => {
    const date = new Date(dateString)
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    if (date.toDateString() === today.toDateString()) return t("Today")
    if (date.toDateString() === tomorrow.toDateString()) return t("Tomorrow")
    return date.toLocaleDateString(undefined, { weekday: "short" })
  }

  return (
    <div className="weather-summary">
      <div className="weather-header">
        <div className="date-time">
  <div className="date">
    <i className="fas fa-calendar-alt"></i>
    <span>{t("Date")}: {new Date().toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}</span>
  </div>
  <div className="time">
    <i className="fas fa-clock"></i>
    <span>{t("Time")}: {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
  </div>
</div>
      </div>

      <div className="weather-main">
        <div className="temperature-display">
          <i className={`fas ${getWeatherIcon()} weather-icon`}></i>
          <div className="temperature">{Math.round(temperature)}°C</div>
          <div className="condition">{t("Avg Temp")}: {tempAvg}°</div>
        </div>

        <div className="weather-metrics">
          {[
            { icon: "fa-thermometer-full", value: `${tempMax}°C`, label: t("Max Temp") },
            { icon: "fa-thermometer-empty", value: `${tempMin}°C`, label: t("Min Temp") },
            { icon: "fa-wind", value: `${windSpeed} km/h`, label: t("Wind Speed (uz)") },
            { icon: "fa-wind", value: `${zw}`, label: t("Wind Height (zw)") },
            { icon: "fa-percentage", value: `${humidityMin}% - ${humidityMax}%`, label: t("Humidity Range") },
            { icon: "fa-sun", value: `${n}`, label: t("Sunshine (n)") },
          ].map((item, index) => (
            <div className="metric-item" key={index}>
              <div className="metric-icon">
                <i className={`fas ${item.icon}`}></i>
              </div>
              <div className="metric-value">{item.value}</div>
              <div className="metric-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      {forecastData?.daily && (
        <div className="forecast-summary">
          <div className="forecast-title">{t("Forecast")}</div>
          <div className="forecast-days">
            {forecastData.daily.slice(0, 7).map((day, index) => (
              <div className="forecast-day" key={index}>
                <div className="day-name">{formatDay(day.date)}</div>
                <div className="day-icon">
                  <i className={`fas ${getWeatherIcon()}`}></i>
                </div>
                <div className="day-temp">
                  <span className="high">{Math.round(day.highTemp)}°</span>
                  <span className="low">{Math.round(day.lowTemp)}°</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default WeatherSummary
